import { render, staticRenderFns } from "./VideoDetails.vue?vue&type=template&id=61a40881&"
import script from "./VideoDetails.vue?vue&type=script&lang=ts&"
export * from "./VideoDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports